module.exports = __webpack_public_path__ + "img/circle-bolt.c96797d.svg";